import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9.413 11.702l8.095-8.095a1.68 1.68 0 0 0 0-2.375l-.74-.741a1.68 1.68 0 0 0-2.375 0L6.298 8.587 4 14l5.413-2.298zm3.976 2.324l-1.731 1.634-1.634-1.635a2.073 2.073 0 0 0-2.926.001L5.77 15.355a2.21 2.21 0 1 1-1.561-3.771v-2c-1.249 0-2.426.55-3.229 1.509a4.23 4.23 0 0 0-.912 3.469A4.192 4.192 0 0 0 4.197 18c1.114 0 2.19-.436 2.987-1.231l1.427-1.329 1.634 1.634a2.072 2.072 0 0 0 2.927 0l1.731-1.634 1.682 1.682 1.414-1.414-1.683-1.683a2.074 2.074 0 0 0-2.927.001z" />
  </svg>
);

export default SvgComponent;
